'use strict';
var createErrorNotification = require('../components/errorNotification');

const SELECTORS = {
    body: 'body',
    replaceCuratedItemsBtn: '.js-cart-replace-lineitems-confirmation-btn',
    replaceCuratedModal: '.js-replace-product-modal',
    generalErrorContainer: '.error-messaging',
};

const handleReplaceCuratedProduct = () => {
    $(SELECTORS.body).on('click', SELECTORS.replaceCuratedItemsBtn, (e) => {
        let $this = $(e.currentTarget);
        let addToCartUrl = $this.data('add-cart-url');
        let addToCartForm = $this.data('add-cart-form');

        let lookBuilderPage = ($('.js-lookbuilder').length > 0);
        let lookbuilderUrl = $this.data('urlredirect');

        $(SELECTORS.replaceCuratedModal).spinner().start();
        $(SELECTORS.body).trigger('product:replaceWithCurated', this);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: addToCartForm,
                success: function (data) {
                    $('body').trigger('product:afterAddToCart', data);
                    $(SELECTORS.replaceCuratedModal).modal('hide');

                    if (data.error) {
                        createErrorNotification($(SELECTORS.generalErrorContainer), data.message);
                        return;
                    }

                    if (!lookBuilderPage) {
                        window.location.href = lookbuilderUrl;
                    }

                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

module.exports = {
    handleReplaceCuratedProduct
};
